export { getUserInfoServerAction } from 'next-flight-server-reference-proxy-loader?id=7f8e6f1031c31f7a4cb5cb19d54466ff33a91174aa&name=getUserInfoServerAction!'